import styled from '@emotion/styled'

const Spinner = styled.div`
  position: absolute;
  top: 50%;
  right: calc(50% - 25px);

  display: inline-block;
  width: 50px;
  height: 50px;
  border: 3px solid rgba(144,161,176,0.6);
  border-radius: 50%;
  border-top-color: rgba(53,58,82,0.8);
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
`

export default Spinner
